export const getCurrentPage = () : string => {
    let href = window.location.href;
    let origin = window.location.origin;
    return href.replace(origin, '');
}